import { paddingLarge, paddingMedium } from "src/styles/spacing";
import { Text } from "src/swsh-native";

const RecapSubtitleContent = ({ subtitle }: { subtitle: string | null | undefined }) => {
	if (!subtitle) return null;
	return (
		<Text
			semibold
			semiLarge
			style={{
				marginTop: paddingMedium,
				marginBottom: paddingLarge,
				paddingHorizontal: paddingLarge,
				textAlign: "center",
			}}
		>
			{subtitle}
		</Text>
	);
};
export default RecapSubtitleContent;
